module.exports = __webpack_public_path__ + "static/img/170903-feature-down-syndrome.7c4e086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170903-feature-down-syndrome.jpg
// module id = BEz3
// module chunks = 0